import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './csocial.css';


const Csocial = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  return (
    <div className='container csocial-container'>
    
        
        <div className='csocial_title'>
            <h2 className='title'>Comité de Contraloría Social del Programa Música para el Pueblo</h2>
            <hr className='hr-gob'/>
         </div>   

            <p>De conformidad con los lineamientos para la promoción y operación de la
            Contraloría Social, se publican aquí los documentos normativos, de difusión y
            capacitación para la vigilancia en la ejecución, ejercicio y aplicación de los
            recursos federales recibidos por la Secretaría de Cultura, en su vertiente de
            Apoyo a Instituciones Estatales de Cultura (AIEC) 2023, para el proyecto Música
            para el Pueblo.</p>
            

           <h4 className='title'>Materiales de difusión</h4>
            <div className='req5'>
            <a href="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir1/2023/normatividad/ConvocatoriaContraloriaSocialAIEC2023.pdf" target="_blank">• Convocatoria para integrar el Comité de Contraloría Social</a>
            </div>
            <div className='req5'>
            <a href="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir1/2023/normatividad/IntegrantesdelcomiteCS.pdf" target="_blank">• Integrantes del Comité de Contraloria Social</a>
            </div>
            <div className='req6'>
            <a href="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir1/2023/normatividad/TripticoContraloriaSocialAIEC2023.pdf" target="_blank">• Tríptico de difusión de actividades</a>
            </div>
            
            <h4 className='title'>Documentos Normativos</h4>

            
            <div className='req8'>
            <a href="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir1/2023/normatividad/EsquemaContraloriaSocialAIEC2023.pdf" target="_blank">• Esquema de Contraloria Social</a>
            </div>
            <div className='req2'>
            <a href="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir1/2023/normatividad/GuiaOperativaContraloriaSocialAIEC2023.pdf" target="_blank">• Guía Operativa de Contraloría Social</a>
            </div>            
            <div className='req3'>
            <a href="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir1/2023/normatividad/ProgramaAnualdeTrabajoCSAIEC2023.pdf" target="_blank">• Programa Anual de Trabajo de Contraloría Social (PATCS) </a>
            </div>
            <div className='req4'>
            <a href="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir1/2023/normatividad/AnexosGuiaOperativaContraloriaSocialAIEC2023.pdf" target="_blank">• Anexos de la Guía Operativa de Contraloría Social</a>
            </div>

            <h4 className='title'>Materiales de capacitación</h4>
            <div className='req7'>
            <a href="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir1/2023/normatividad/CapacitacionContraloriaSocialAIEC2023.pdf" target="_blank">• AIEC y la Contraloría social</a>
            </div>             

            <h4 className='title'></h4>

            

    </div>
  )
}

export default Csocial